import styled, { css } from "styled-components";

export const Container = styled.header`
  width: 100%;
  height: ${({ theme }) => theme.spacing.headerHeight};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .logo a {
    display: flex;
    gap: 11px;
    align-items: center;
    font-weight: 700;
    font-size: 2rem;
    color: ${({ theme }) => theme.colors.secondary.health_green};
    transition: 0.2s;

    :hover {
      opacity: 0.7;
    }
  }

  @media screen and (max-width: 1020px) {
    padding: 0 2.5rem;
    .logo svg:first-of-type {
      display: none;
    }
    .logo a {
      font-size: 1.5rem;
    }
  }

  @media screen and (max-width: 675px) {
    height: 4.5rem;
    padding: 0;

    .logo a svg:first-child {
      display: none;
    }
  }
  @media screen and (max-width: 500px) {
    height: 4.5rem;

    .logo a svg:first-child {
      display: none;
    }
  }
`;

export const MenuDesktop = styled.div`
  display: flex;
  gap: 3rem;
  align-items: center;

  .logout {
    position: relative;
    font-size: ${({ theme }) => theme.fontSize.fontSize.fontSizeLG};
    font-weight: 700;
    color: ${({ theme }) => theme.colors.secondary.health_green};
    transition: 0.2s all;
    height: 2.5rem;

    :hover {
      opacity: 0.7;
    }

    > svg {
      font-size: ${({ theme }) => theme.fontSize.fontSize.fontSize3xL};
    }
  }

  a {
    border-radius: 8px;

    :nth-child(3) {
      background-color: ${({ theme }) => theme.colors.secondary.health_green};

      button {
        color: #ffffff;

        :hover {
          opacity: 1;
          background-color: #007756;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MenuMobile = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    gap: 1rem;

    button {
      border-radius: 8px;
      transition: 0.2s;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      color: ${({ theme }) => theme.colors.secondary.health_green};
      width: 24px;
      height: 24px;
      justify-content: center;

      :hover {
        opacity: 0.7;
      }

      :last-child {
        ${(props) =>
    !props.isLogged &&
    css`
            display: none;
          `}
      }
    }
  }
`;
